import { createQueryKeys } from '@lukemorales/query-key-factory';

export const b2bDashboard = createQueryKeys('b2bDashboard', {
  dashboard: (agent: string) => [agent],
  agentHome: null,
});
